import { Typography } from "@mui/material";

function PageTitle({title, ...props}){
    return <Typography color="primary.main" variant="h1" {...props}>{title}</Typography>
}

export default PageTitle;